<template name="errorMsg">
  <label class="error-msg"  v-show="isError">
    {{ errorName || $t('required') }}
  </label>
</template>

<script type="text/javascript">
export default {
  name: 'errorMsg',
  props: {
    errorName: String,
    isError: Boolean,
  },
  data() {
    return {
    };
  },
  methods: {
  },
};
</script>

<style scoped lang="scss">
  .error-msg {
    color: #e42029;
    font-size: 11px;
    text-align: right;
    width: 100%;
  }
</style>
